var $92ef254c82a5c769$exports = {};
$92ef254c82a5c769$exports = {
    "Clear search": `\u{5E0}\u{5E7}\u{5D4} \u{5D7}\u{5D9}\u{5E4}\u{5D5}\u{5E9}`
};


export {$92ef254c82a5c769$exports as default};
//# sourceMappingURL=he-IL.module.js.map
